import { Box, Text } from '@chakra-ui/react'
import { Link } from 'react-router-dom'

import { Asset, Call, Equipment } from '@/services/backend/config/entities'

import { Chamados } from '..'

type Extended = Call & {
  Asset: Asset & { Equipment?: Equipment }
}

interface Props {
  redirectTo: string
  data: Extended
}

export default function Component({ data, redirectTo }: Props) {
  return (
    <Link to={redirectTo}>
      <Box
        borderBottom="1px solid"
        borderBottomColor="gray.200"
        p={2}
        _hover={{ bg: 'blackAlpha.50' }}
      >
        <Text fontSize="xs">{new Date(data.createdAt).toLocaleString()}</Text>
        <Text fontWeight="bold">{data.id}</Text>
        <Text fontSize="sm">{data.description}</Text>
        <Chamados.Core.TempoAtendimento_ProgressBar
          status={data.status}
          createdAt={data.createdAt}
        />
      </Box>
    </Link>
  )
}
